import { INavLinkGroup } from "@fluentui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthService from "../../services/authService";
import TokenService from "../../services/tokenService";
import { keyAccess, keyJwt } from "../../utils/helpers/helpers";
import {
  CLAIM_ADRESS,
  CLAIM_COD_CONT,
  CLAIM_ROLE,
  CLAIM_TOKEN_SESION_C,
} from "../../utils/helpers/roleHelpers";
import { AuthContext } from "../context/auth-context";
import { IUserAuthenticate, IUserState } from "../interface/IAuth";
import { fakeAuthProvider } from "./fake-provider";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();

  const [token, setToken] = useState<string | null>(TokenService.getToken());
  const [access, setAccess] = useState<IUserAuthenticate | null>(
    AuthService.getAccess()
  );
  const [sidebar, setSidebar] = useState<INavLinkGroup[]>([]);

  // UseEffect
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  /* Effect */
  useEffect(() => {
    if (token) {
      localStorage.setItem(keyJwt, `"${token}"`);
      let t: any = JSON.parse(atob(token.split(".")[1]));

      setAccess({
        ...access,
        email: t[CLAIM_ADRESS],
        role: validateRole(t[CLAIM_ROLE]),
        codCont: t[CLAIM_COD_CONT],
        tokenSesionC: t[CLAIM_TOKEN_SESION_C],
      });

      getSiderBar();
    } else {
      localStorage.removeItem(keyJwt);
    }
  }, [token]);

  useEffect(() => {
    if (token && sidebar.length > 0) {
      setAccess({
        ...access,
        sidebar: sidebar,
      });
    } else {
      localStorage.removeItem(keyAccess);
    }
  }, [sidebar]);

  useEffect(() => {
    if (access) {
      localStorage.setItem(keyAccess, JSON.stringify(access));
    } else {
      localStorage.removeItem(keyAccess);
    }
  }, [access]);

  const getSiderBar = () => {
    AuthService.access()
      .then((res) => {
        if (res.status === 200) {
          setSidebar(res.data);
        }
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const validateRole = (claim: any) => {
    if (Array.isArray(claim)) {
      return claim;
    } else {
      if (typeof claim == "undefined" || claim == null) {
        return [];
      } else {
        let r = [claim];

        return r;
      }
    }
  };
  const getToken = () => {
    let c = localStorage.getItem(keyJwt);
    if (c && c != "") {
      return c.substring(1, c.length - 1);
    }
    return null;
  };
  const getRoles=()=>{
    const Token =getToken()
    if(Token==null)
      return []
    let t: any = JSON.parse(atob(Token.split('.')[1]));
         return validateRole(t[CLAIM_ROLE])
  }
  const hasRequiredRole = (role:string) => {
    const userRoles = getRoles();
    return userRoles.some(userRol=>userRol===role);
  };

  let signin = (authenticate: IUserState, callback: VoidFunction) => {
    return fakeAuthProvider.signin(() => {
      setToken(authenticate.token ?? null);
      callback();
    });
  };

  let signout = (callback: VoidFunction) => {
    return fakeAuthProvider.signout(() => {
      setToken(null);
      setAccess(null);
      callback();
    });
  };

  let value = { token, access, signin, signout,hasRequiredRole };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
